export default __webpack_public_path__ + "static/media/Group846.819cd8e4.svg";